import type { RouteRecordRaw } from 'vue-router'
import AuthLayout from '@/features/auth/components/AuthLayout.vue'
import AuthLogin from '@/features/auth/components/AuthLoginSso.vue'
import ViewAuthLogin from '@/features/auth/components/AuthLoginUsername.vue'

export default [
  { path: '/login',
    component: AuthLayout,
    meta: {
      requiresAuth: false,
      pageTitle: 'Login'
    },
    children: [
        // Default (Microsoft SSO)
      { path: '', component: AuthLogin, name: 'auth.login' },

      // Credentials (email & password)
      { path: 'email', component: ViewAuthLogin, name: 'auth.login.email'},
    ]
  }
] satisfies RouteRecordRaw[] as RouteRecordRaw[]
